import lozad from 'lozad';
import Headroom from 'headroom.js';

export default {
    init() {
        // JavaScript to be fired on all pages

        // PRELOADER
        // $(window).on('load', function () {
        //     $('.loader').fadeOut();
        //     $('.loader-mask')
        //         .delay(350)
        //         .fadeOut('slow');
        // });

        // INIT LOZAD
        (function () {
            const observer = lozad(); // lazy loads elements with default selector as '.lozad'
            observer.observe();            
        })();

        // ADESTRA FORM
        (function () {
            var $container = $('.amf-form');

            $container.each(function () {
                var $form = $(this).find('form');
                var $submit = $form.find('input[type=submit]');

                var inputs = $form.find('input');
                var submit_count = 0; // eslint-disable-line

                var enable_double_submit = false; // eslint-disable-line

                for (var i = 0; i < inputs.length; i++) {
                    var my_input = inputs[i];
                    if (my_input.type === 'submit') {
                        var container = my_input.parentNode;
                        if (container.className.match(/enable-double-submit/)) {
                            enable_double_submit = true;
                        }
                    }

                    if (
                        $(my_input)
                            .closest('.amf-el')
                            .hasClass('required')
                    ) {
                        $(my_input).attr('required', true);
                    }
                    if (
                        $(my_input)
                            .closest('.amf-el')
                            .hasClass('amf-type-email')
                    ) {
                        $(my_input).prop('type', 'email');
                    }
                }

                $submit.on('click', function (e) {
                    if (grecaptcha.getResponse().length === 0) { // eslint-disable-line
                        e.preventDefault();
                        alert('Please click the reCAPTCHA checkbox');
                    }
                });

                // if($submit.length) {
                //   $submit.unbind();

                //   $submit.on('click', function(evt) {
                //     evt.preventDefault();
                //     // if (submit_count >= 1 && !enable_double_submit) {
                //     //   valid = false;
                //     // }
                //     // submit_count++;

                //     if(grecaptcha.getResponse().length == 0) {
                //       alert('Please click the reCAPTCHA checkbox');
                //     }

                //   });
                // }
            });
        })();

        // DYNAMIC HEIGHT CONTENT
        (function () {
            // Configure/customize these variables.
            var showCharacters = 800; // How many characters are shown by default
            var ellipsestext = '...';
            var moretext = 'READ MORE';
            var lesstext = 'READ LESS';

            var container = $('.dynamic-height-content');

            container.each(function () {
                var content = $(this).html();

                // console.log(String(content));


                if (content.length > showCharacters) {

                    var text = $.trim(content);

                    var c = text.replace(/^(.{800}[^\s]*).*/, '$1');

                    var h = text.replace(c, '');

                    var html =
                        c +
                        '<span class="more-ellipses">' +
                        ellipsestext +
                        '&nbsp;</span><span class="more-content" style="display:inline;"><span class="mc-wrap" style="display:none;">' +
                        h +
                        '</span><button class="more-link btn btn-outline-tertiary mt-3">' +
                        moretext +
                        '</button></span>';

                    $(this).html(html);
                }
            });

            container.find('.more-link').click(function () {
                if ($(this).hasClass('less')) {
                    $(this).removeClass('less');
                    $(this).html(moretext);
                } else {
                    $(this).addClass('less');
                    $(this).html(lesstext);
                }
                $(this)
                    .parent()
                    .prev()
                    .toggle();
                $(this)
                    .prev()
                    .toggle();
                return false;
            });
        })();

        // PRIMARY MENU TOGGLE
        (function () {
            var primaryMenu = $('#jsPrimaryMenu');
            var menuToggler = $('#jsPrimaryMenuToggler');
            var closeMenu = $('#jsCloseMenu');
            const observerOnDemand = lozad('.lozad-ondemand');

            function toggleClassMenu() {
                if (!primaryMenu.hasClass('primary-menu--visible')) {
                    primaryMenu.addClass('primary-menu--animatable');
                    primaryMenu.addClass('primary-menu--visible');
                    observerOnDemand.observe();
                } else {
                    primaryMenu.addClass('primary-menu--animatable');
                    primaryMenu.removeClass('primary-menu--visible');

                    if (
                        $('.place-info, .experience-info').hasClass(
                            'slide-info--visible'
                        )
                    ) {
                        $('.place-info, .experience-info').addClass(
                            'slide-info--animatable'
                        );
                        $('.place-info, .experience-info').removeClass(
                            'slide-info--visible'
                        );
                    }
                }
            }
            function OnTransitionEnd() {
                primaryMenu.removeClass('primary-menu--animatable');
            }

            primaryMenu.on('transitionend', OnTransitionEnd);
            menuToggler.on('click', toggleClassMenu);
            closeMenu.on('click', toggleClassMenu);
        })();

        // PRIMARY SUBMENU COLLAPSE
        (function () {
            var main_menu = $('#jsPrimaryMenu .main-menu');

            main_menu.each(function (j) {
                var menu_with_children = $(this).find('.menu-item-has-children');

                menu_with_children.each(function (i) {
                    var $this = $(this);

                    $this
                        .find('>a')
                        .addClass('collapsed')
                        .attr({
                            'data-toggle': 'collapse',
                            'data-target': '#collapse' + j + i,
                        });
                    $this
                        .find('>.sub-menu')
                        .addClass('collapse')
                        .attr('id', 'collapse' + j + i);
                });
            });
        })();

        // PRIMARY MENU ITEMS INFO SLIDE
        (function () {
            var primaryMenu = $('#jsPrimaryMenu');
            var infoSlide = primaryMenu.find('[data-toggle="info_slide"]');

            infoSlide.each(function () {
                var $this = $(this);



                $this.on('mouseenter', function () {
                    var target = $($(this).attr('data-target'));

                    if (
                        $('.place-info, .experience-info').hasClass(
                            'slide-info--visible'
                        )
                    ) {
                        $('.place-info, .experience-info').addClass(
                            'slide-info--animatable'
                        );
                        $('.place-info, .experience-info').removeClass(
                            'slide-info--visible'
                        );
                    }

                    if (!target.hasClass('slide-info--visible')) {
                        target.addClass('slide-info--animatable');
                        target.addClass('slide-info--visible');
                    }

                    target.on('transitionend', function () {
                        target.removeClass('slide-info--animatable');
                    });
                });
            });
        })();
        
        (function () {
            $('#jsHomeSlider').slick({
                dots: true,
                arrows: false, 
                infinite: true,
                speed: 1400,
                autoplay: true,
                autoplaySpeed: 8000,
                fade: true,
                pauseOnHover: false,
                cssEase: 'ease-in-out',
                // initialSlide: 2,
                customPaging: function (slick, i) {
                    var paging_title = slick.$slides
                        .eq(i)
                        .find('.home-slider__item')
                        .data('paging-title');
                    var paging_subtitle = slick.$slides
                        .eq(i)
                        .find('.home-slider__item')
                        .data('paging-subtitle');
                    return (
                        '<a class="home-slider__paging">' +
                        paging_subtitle +
                        '<span>' +
                        paging_title +
                        '</span></a>'
                    );
                },
            });
            $('#jsHeroSlider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                fade: true,
                speed: 1000,
                autoplaySpeed: 2000,
                pauseOnHover: false,
                cssEase: 'linear',
                //asNavFor: '#jsHeroSliderNav'
            });

            var $heroSliderNav = $('#jsHeroSliderNav');

            $heroSliderNav.on('init', function (slick) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (slick.slideCount < 2) {
                    $(this).hide();
                }
            });

            $heroSliderNav.slick({
                centerMode: true,
                centerPadding: '30%',
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                asNavFor: '#jsHeroSlider',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            centerPadding: '0',
                        },
                    },
                ],
            });

            var $fancySlider = $('#jsFancySlider, #jsFancySliderAccommodation');

            $fancySlider.on('init', function (slick) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                if (slick.slideCount < 2) {
                    $(this).hide();
                }
            });

            $fancySlider.slick({
                centerMode: true,
                centerPadding: '30%',
                arrows: true,
                infinite: true,
                autoplay: true,
                pauseOnHover: true,
                slidesToShow: 1,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            centerPadding: '0',
                        },
                    },
                ],
            });


            var $threeSlideCarousel = $('.three-slide-carousel');

            $threeSlideCarousel.each(function () {
                var $that = $(this);
                var $slick_prev = $that.next('.three-slide-carousel-nav').find('.slick-prev');
                var $slick_next = $that.next('.three-slide-carousel-nav').find('.slick-next');

                $that.slick({
                    centerMode: true,
                    centerPadding: '10%',
                    arrows: true,
                    infinite: true,
                    autoplay: true,
                    pauseOnHover: true,
                    slidesToShow: 3,
                    focusOnSelect: true,
                    prevArrow: $slick_prev,
                    nextArrow: $slick_next,
                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                slidesToShow: 2,
                                centerPadding: '15%',
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1,
                                centerPadding: '15%',
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                centerPadding: '0',
                            },
                        },
                    ],
                });
            });

            // $('#jsRegionCarousel').slick({
            //     arrows: true,
            //     prevArrow: $('#regionSlickPrev'),
            //     nextArrow: $('#regionSlickNext'),
            // });

            // $('#jsForgetableCarousel').slick({
            //     arrows: true,
            // });

            var $oneSlideCarousel = $('.one-slide-carousel');

            $oneSlideCarousel.each(function () {
                var $that = $(this);
                var $slick_prev = $that.next('.one-slide-carousel-nav').find('.slick-prev');
                var $slick_next = $that.next('.one-slide-carousel-nav').find('.slick-next');

                $that.slick({
                    centerMode: true,
                    centerPadding: '0',
                    arrows: true,
                    infinite: true,
                    autoplay: true,
                    pauseOnHover: true,
                    slidesToShow: 3,
                    focusOnSelect: true,
                    prevArrow: $slick_prev,
                    nextArrow: $slick_next,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                centerPadding: '0',
                                slidesToShow: 1,
                                adaptiveHeight: true,
                            },
                        },
                    ],
                });
            });

            $('#jsTestimonialsSlider').slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                pauseOnHover: true,
                speed: 1500,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        })();

        // TOP PICS
        (function ($) {
            $('#jsTopPicks')
                .on('mouseover', '.top-pick__thumbnail', function () {
                    var $this = $(this);
                    $this.parent('.top-pick').addClass('active');
                })
                .on('mouseleave', '.top-pick__thumbnail', function () {
                    var $this = $(this);
                    $this.parent('.top-pick').removeClass('active');
                });
        })(jQuery);

        // AJAX load posts
        (function () {
            var sectionContainer = $('.ajax-posts');

            sectionContainer.each(function (index, el) { // eslint-disable-line
                var $this = $(this),
                    postsContainer = $this.find('.posts-list'),
                    loadPostsBtn = $this.find('.ajax-cta button'),
                    btnText = loadPostsBtn.text(),
                    queryVars = loadPostsBtn.data('query-vars'),
                    postsPerPage = queryVars.posts_per_page,
                    offset = queryVars.offset,
                    totalCount = loadPostsBtn.data('total');

                function appendData(dataArray) {
                    for (var i = 0; i < dataArray.length; i++) {
                        var markup = dataArray[i];
                        // Convert HTML string into DOM object of new document
                        var postDocument = new DOMParser().parseFromString(
                            markup,
                            'text/html'
                        );
                        // Get the post DOM object
                        var post = postDocument.body.firstChild;
                        var animationDelay = 0.3 * i;

                        post.style.animationDelay = animationDelay + 's';
                        postsContainer.append(post);
                    }
                }

                function noMorePosts() {
                    // This function runs after we've loaded the final post.
                    loadPostsBtn.remove();
                }

                loadPostsBtn.click(function (event) {
                    // console.log(queryVars);
                    event.target.innerHTML = 'LOADING...';

                    $.ajax({
                        url: ajaxurl, // eslint-disable-line
                        type: 'post',
                        data: {
                            action: 'ajax_load_posts',
                            queryVars: queryVars,
                        },
                        beforeSend: function () {
                            sectionContainer.attr('data-loading', 'true');
                        },
                        complete: function () {
                            sectionContainer.attr('data-loading', 'false');
                        },
                        success: function (jsonData) {
                            //console.log(jsonData);
                            event.target.innerHTML = btnText;

                            var data = JSON.parse(jsonData);
                            //console.log(data);

                            if (offset + postsPerPage >= totalCount) {
                                appendData(data.posts);
                                noMorePosts();
                            } else {
                                appendData(data.posts);
                            }

                            // Increment the offset
                            offset += postsPerPage;
                            queryVars.offset = offset;
                        },
                        error: function (MLHttpRequest, textStatus, errorThrown) {
                            alert(errorThrown);
                        },
                    });
                });
            });
        })();

        // INITIALIZE HEADROOM
        (function () {
            var header = document.querySelector('.navbar');

            if (header !== null) {
                if (window.location.hash) {
                    header.classList.add('headroom--unpinned');
                }
                var headroom = new Headroom(header, {
                    tolerance: {
                        down: 0,
                        up: 0,
                    },
                    offset: 20,
                    classes: {
                        // initial: 'animated',
                        // pinned: 'fadeInDown',
                        // unpinned: 'fadeOutUp',
                        // onUnpin: function () {
                        //   console.log('unpinned');
                        // }
                    },
                });
                headroom.init();
            }
        })();

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js